import { Vec2, deg2rad } from '@lakaran/geometry';

export const DEFAULT_ANGLE_STEP_DEG = 45;

/**
 * Projects `point` onto the nearest ray of `stepDeg` from `reference` — the drafting
 * "hold Ctrl" constraint. Keeps the projected distance, so the cursor still drives length.
 */
export function constrainToAngleStep(
  reference: Vec2,
  point: Vec2,
  stepDeg: number = DEFAULT_ANGLE_STEP_DEG,
): Vec2 {
  const delta = point.sub(reference);
  if (delta.isZero(1e-12)) return point;
  const step = deg2rad(stepDeg);
  if (step <= 0) return point;

  const snappedAngle = Math.round(delta.angle() / step) * step;
  const projectedLength = delta.dot(Vec2.polar(1, snappedAngle));
  return reference.add(Vec2.polar(Math.max(projectedLength, 0), snappedAngle));
}

/** Constraint angle in degrees normalised to [0, 360), for UI feedback. */
export function constrainedAngleDeg(
  reference: Vec2,
  point: Vec2,
  stepDeg: number = DEFAULT_ANGLE_STEP_DEG,
): number {
  const delta = point.sub(reference);
  if (delta.isZero(1e-12)) return 0;
  const step = deg2rad(stepDeg);
  const degrees = (Math.round(delta.angle() / step) * step * 180) / Math.PI;
  return ((degrees % 360) + 360) % 360;
}
